module.exports = __webpack_public_path__ + "img/GERA_Was-wir-tun_Pic4.jpg";